// const SM4 = require("gm-crypt").sm4;
// const pwdKey = "GJstSK_WJd=gdqyh"; //"GJstSK_YBD=gSOFT"; 密钥  前后端一致即可,后端提供
// let sm4Config = {
//   key: pwdKey, //这里这个key值要与后端的一致，后端解密是根据这个key
//   mode: "CBC",  // 加密的方式有两种，ecb和cbc两种，也是看后端如何定义的，不过要是cbc的话下面还要加一个iv的参数，ecb不用
//   iv: '8730246610101342', //iv是cbc模式的第二个参数，也需要跟后端配置的一致 iv是initialization vector的意思，就是加密的初始话矢量，初始化加密函数的变量，也叫初始向量。（本来应该动态生成的，由于项目没有严格的加密要求，直接写死一个）
//   // cipherType: "base64"
// };

// const sm4Util = new SM4(sm4Config); // new一个sm4函数，将上面的sm4Config作为参数传递进去。

// /* 
//  * 加密工具函数
//  * @param {String} text 待加密文本
//  */
// export function encrypt(text) {
//   return sm4Util.encrypt(text, pwdKey);
// }

// /*
//  * 解密工具函数
//  * @param {String} text 待解密密文
//  */
// export function decrypt(text) {
//   return sm4Util.decrypt(text, pwdKey);
// }
import SM4 from "@/utils/sm4/sm4.js";  //导入sm4.js文件
const pwdKey = "GJstSK_WJd=gdqyh"; //"GJstSK_YBD=gSOFT"; 密钥  前后端一致即可,后端提供
const iv = "8730246610101342"; //iv是cbc模式的第二个参数，也需要跟后端配置的一致
let params = { //使用base16编码转换key和iv
  key: pwdKey,
  iv: iv,
  mode: "cbc",
};
export function encrypt(text) {
  let msgString = text;
  if (typeof (msgString) !== 'string') {
    console.log('text111: ', text)
    msgString = JSON.stringify(text);
  }
  // console.log("接口入参未加密*****************", text);
  SM4.constructorInit(params);
  return SM4.encrypt(msgString)
}
export function decrypt(text) {
  SM4.constructorInit(params);
  // console.log(JSON.parse(SM4.decrypt(text)), "解密结果");
  console.log('text222: ', text, ' - ',  SM4.decrypt(text))
  let str = ''
  try {
    str = JSON.parse(SM4.decrypt(text))
  } catch (error) {
    str = SM4.decrypt(text)
  }
  return str
}

  



export const strToHexCharCode = (str) => { //转换base16编码
  var hexCharCode = [];
  var chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
  for (var i = 0; i < str.length; i++) {
      var bit = (str[i] & 0x0f0) >> 4;
      hexCharCode.push(chars[bit]);
      var bit = str[i] & 0x0f;
      hexCharCode.push(chars[bit]);
  }
  return hexCharCode.join("");
}

export const strToUtf8Bytes = (str) => { //转换utf8
  const utf8 = [];
  for (let ii = 0; ii < str.length; ii++) {
      let charCode = str.charCodeAt(ii);
      if (charCode < 0x80) utf8.push(charCode);
      else if (charCode < 0x800) {
          utf8.push(0xc0 | (charCode >> 6), 0x80 | (charCode & 0x3f));
      } else if (charCode < 0xd800 || charCode >= 0xe000) {
          utf8.push(0xe0 | (charCode >> 12), 0x80 | ((charCode >> 6) & 0x3f), 0x80 | (charCode & 0x3f));
      } else {
          ii++;
          charCode = 0x10000 + (((charCode & 0x3ff) << 10) | (str.charCodeAt(ii) & 0x3ff));
          utf8.push(
              0xf0 | (charCode >> 18),
              0x80 | ((charCode >> 12) & 0x3f),
              0x80 | ((charCode >> 6) & 0x3f),
              0x80 | (charCode & 0x3f)
          )
      }
  }
  for (let jj = 0; jj < utf8.length; jj++) {
      var code = utf8[jj];
      if (code > 127) {
          utf8[jj] = code - 256;
      }
  }
  return utf8;
}
